import { indexFirstById } from '~/utils/indexFirstById'
import type { MenuCategoriesSource } from '~/utils/MenuCategoriesSource'

/** One pass over every menu and category; a menu item listed twice resolves to its first listing. */
export const indexMenuItemsById = <T extends { id: number }>(
  menus: readonly MenuCategoriesSource<T>[]
): Map<number, T> => {
  const index = new Map<number, T>()
  for (const menu of menus) {
    for (const category of menu.categories) indexFirstById(category.menu_items, index)
  }
  return index
}
